/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.Country_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.Country domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum Country_ {
   /// <summary>
   ///    ()
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Andorra (AD)
   /// </summary>
   AD = 1,
   /// <summary>
   ///   United Arab Emirates (AE)
   /// </summary>
   AE = 2,
   /// <summary>
   ///   Afghanistan (AF)
   /// </summary>
   AF = 3,
   /// <summary>
   ///   Antigua and Barbuda (AG)
   /// </summary>
   AG = 4,
   /// <summary>
   ///   Anguilla (AI)
   /// </summary>
   AI = 5,
   /// <summary>
   ///   Albania (AL)
   /// </summary>
   AL = 6,
   /// <summary>
   ///   Armenia (AM)
   /// </summary>
   AM = 7,
   /// <summary>
   ///   Dutch Antilles (AN)
   /// </summary>
   AN = 8,
   /// <summary>
   ///   Angola (AO)
   /// </summary>
   AO = 9,
   /// <summary>
   ///   Antarctica (AQ)
   /// </summary>
   AQ = 10,
   /// <summary>
   ///   Argentina (AR)
   /// </summary>
   AR = 11,
   /// <summary>
   ///   American Samoa (AS)
   /// </summary>
   AS = 12,
   /// <summary>
   ///   Austria (AT)
   /// </summary>
   AT = 13,
   /// <summary>
   ///   Australia (AU)
   /// </summary>
   AU = 14,
   /// <summary>
   ///   Aruba (AW)
   /// </summary>
   AW = 15,
   /// <summary>
   ///   Azerbaijan (AZ)
   /// </summary>
   AZ = 16,
   /// <summary>
   ///   Bosnia and Herzegovina (BA)
   /// </summary>
   BA = 17,
   /// <summary>
   ///   Barbados (BB)
   /// </summary>
   BB = 18,
   /// <summary>
   ///   Bangladesh (BD)
   /// </summary>
   BD = 19,
   /// <summary>
   ///   Belgium (BE)
   /// </summary>
   BE = 20,
   /// <summary>
   ///   Burkina Faso (BF)
   /// </summary>
   BF = 21,
   /// <summary>
   ///   Bulgaria (BG)
   /// </summary>
   BG = 22,
   /// <summary>
   ///   Bahrain (BH)
   /// </summary>
   BH = 23,
   /// <summary>
   ///   Burundi (BI)
   /// </summary>
   BI = 24,
   /// <summary>
   ///   Benin (BJ)
   /// </summary>
   BJ = 25,
   /// <summary>
   ///   Bermuda (BM)
   /// </summary>
   BM = 26,
   /// <summary>
   ///   Brunei (BN)
   /// </summary>
   BN = 27,
   /// <summary>
   ///   Bolivia (BO)
   /// </summary>
   BO = 28,
   /// <summary>
   ///   Brazil (BR)
   /// </summary>
   BR = 29,
   /// <summary>
   ///   Bahamas, The (BS)
   /// </summary>
   BS = 30,
   /// <summary>
   ///   Bhutan (BT)
   /// </summary>
   BT = 31,
   /// <summary>
   ///   Bouvet Island (BV)
   /// </summary>
   BV = 32,
   /// <summary>
   ///   Botswana (BW)
   /// </summary>
   BW = 33,
   /// <summary>
   ///   Belarus (BY)
   /// </summary>
   BY = 34,
   /// <summary>
   ///   Belize (BZ)
   /// </summary>
   BZ = 35,
   /// <summary>
   ///   Canada (CA)
   /// </summary>
   CA = 36,
   /// <summary>
   ///   Cocos (Keeling) Islands (CC)
   /// </summary>
   CC = 37,
   /// <summary>
   ///   Central African Republic (CF)
   /// </summary>
   CF = 38,
   /// <summary>
   ///   Congo (Brazzaville) (CG)
   /// </summary>
   CG = 39,
   /// <summary>
   ///   Switzerland (CH)
   /// </summary>
   CH = 40,
   /// <summary>
   ///   Cote D'Ivoire (CI)
   /// </summary>
   CI = 41,
   /// <summary>
   ///   Cook Islands (CK)
   /// </summary>
   CK = 42,
   /// <summary>
   ///   Chile (CL)
   /// </summary>
   CL = 43,
   /// <summary>
   ///   Cameroon (CM)
   /// </summary>
   CM = 44,
   /// <summary>
   ///   China (CN)
   /// </summary>
   CN = 45,
   /// <summary>
   ///   Colombia (CO)
   /// </summary>
   CO = 46,
   /// <summary>
   ///   Costa Rica (CR)
   /// </summary>
   CR = 47,
   /// <summary>
   ///   Cuba (CU)
   /// </summary>
   CU = 48,
   /// <summary>
   ///   Cabo Verde (CV)
   /// </summary>
   CV = 49,
   /// <summary>
   ///   Christmas Island (CX)
   /// </summary>
   CX = 50,
   /// <summary>
   ///   Cyprus (CY)
   /// </summary>
   CY = 51,
   /// <summary>
   ///   Czech Republic (CZ)
   /// </summary>
   CZ = 52,
   /// <summary>
   ///   Germany (DE)
   /// </summary>
   DE = 53,
   /// <summary>
   ///   Djibouti (DJ)
   /// </summary>
   DJ = 54,
   /// <summary>
   ///   Denmark (DK)
   /// </summary>
   DK = 55,
   /// <summary>
   ///   Dominica (DM)
   /// </summary>
   DM = 56,
   /// <summary>
   ///   Dominican Republic (DO)
   /// </summary>
   DO = 57,
   /// <summary>
   ///   Algeria (DZ)
   /// </summary>
   DZ = 58,
   /// <summary>
   ///   Ecuador (EC)
   /// </summary>
   EC = 59,
   /// <summary>
   ///   Estonia (EE)
   /// </summary>
   EE = 60,
   /// <summary>
   ///   Egypt (EG)
   /// </summary>
   EG = 61,
   /// <summary>
   ///   Eritrea (ER)
   /// </summary>
   ER = 62,
   /// <summary>
   ///   Spain (ES)
   /// </summary>
   ES = 63,
   /// <summary>
   ///   Ethiopia (ET)
   /// </summary>
   ET = 64,
   /// <summary>
   ///   Finland (FI)
   /// </summary>
   FI = 65,
   /// <summary>
   ///   Fiji (FJ)
   /// </summary>
   FJ = 66,
   /// <summary>
   ///   Falkland Islands (FK)
   /// </summary>
   FK = 67,
   /// <summary>
   ///   Micronesia, Federated States Of (FM)
   /// </summary>
   FM = 68,
   /// <summary>
   ///   Faroe Islands (FO)
   /// </summary>
   FO = 69,
   /// <summary>
   ///   France (FR)
   /// </summary>
   FR = 70,
   /// <summary>
   ///   Gabon (GA)
   /// </summary>
   GA = 71,
   /// <summary>
   ///   United Kingdom (GB)
   /// </summary>
   GB = 72,
   /// <summary>
   ///   Grenada (GD)
   /// </summary>
   GD = 73,
   /// <summary>
   ///   Georgia (GE)
   /// </summary>
   GE = 74,
   /// <summary>
   ///   French Guiana (GF)
   /// </summary>
   GF = 75,
   /// <summary>
   ///   Ghana (GH)
   /// </summary>
   GH = 76,
   /// <summary>
   ///   Gibraltar (GI)
   /// </summary>
   GI = 77,
   /// <summary>
   ///   Greenland (GL)
   /// </summary>
   GL = 78,
   /// <summary>
   ///   Gambia, The (GM)
   /// </summary>
   GM = 79,
   /// <summary>
   ///   Guinea (GN)
   /// </summary>
   GN = 80,
   /// <summary>
   ///   Guadeloupe (GP)
   /// </summary>
   GP = 81,
   /// <summary>
   ///   Equatorial Guinea (GQ)
   /// </summary>
   GQ = 82,
   /// <summary>
   ///   Greece (GR)
   /// </summary>
   GR = 83,
   /// <summary>
   ///   S. Georgia, S. Sandwich Islands (GS)
   /// </summary>
   GS = 84,
   /// <summary>
   ///   Guatemala (GT)
   /// </summary>
   GT = 85,
   /// <summary>
   ///   Guam (GU)
   /// </summary>
   GU = 86,
   /// <summary>
   ///   Guinea-Bissau (GW)
   /// </summary>
   GW = 87,
   /// <summary>
   ///   Guyana (GY)
   /// </summary>
   GY = 88,
   /// <summary>
   ///   Hong Kong (HK)
   /// </summary>
   HK = 89,
   /// <summary>
   ///   Heard Island, McDonald Islands (HM)
   /// </summary>
   HM = 90,
   /// <summary>
   ///   Honduras (HN)
   /// </summary>
   HN = 91,
   /// <summary>
   ///   Croatia (HR)
   /// </summary>
   HR = 92,
   /// <summary>
   ///   Haiti (HT)
   /// </summary>
   HT = 93,
   /// <summary>
   ///   Hungary (HU)
   /// </summary>
   HU = 94,
   /// <summary>
   ///   Indonesia (ID)
   /// </summary>
   ID = 95,
   /// <summary>
   ///   Ireland (IE)
   /// </summary>
   IE = 96,
   /// <summary>
   ///   Israel (IL)
   /// </summary>
   IL = 97,
   /// <summary>
   ///   India (IN)
   /// </summary>
   IN = 98,
   /// <summary>
   ///   British Indian Ocean Territory (IO)
   /// </summary>
   IO = 99,
   /// <summary>
   ///   Iraq (IQ)
   /// </summary>
   IQ = 100,
   /// <summary>
   ///   Iran (IR)
   /// </summary>
   IR = 101,
   /// <summary>
   ///   Iceland (IS)
   /// </summary>
   IS = 102,
   /// <summary>
   ///   Italy (IT)
   /// </summary>
   IT = 103,
   /// <summary>
   ///   Jamaica (JM)
   /// </summary>
   JM = 104,
   /// <summary>
   ///   Jordan (JO)
   /// </summary>
   JO = 105,
   /// <summary>
   ///   Japan (JP)
   /// </summary>
   JP = 106,
   /// <summary>
   ///   Kenya (KE)
   /// </summary>
   KE = 107,
   /// <summary>
   ///   Kyrgyzstan (KG)
   /// </summary>
   KG = 108,
   /// <summary>
   ///   Cambodia (KH)
   /// </summary>
   KH = 109,
   /// <summary>
   ///   Kiribati (KI)
   /// </summary>
   KI = 110,
   /// <summary>
   ///   Comoros (KM)
   /// </summary>
   KM = 111,
   /// <summary>
   ///   Saint Kitts And Nevis (KN)
   /// </summary>
   KN = 112,
   /// <summary>
   ///   Korea, North (KP)
   /// </summary>
   KP = 113,
   /// <summary>
   ///   Korea, South (KR)
   /// </summary>
   KR = 114,
   /// <summary>
   ///   Kuwait (KW)
   /// </summary>
   KW = 115,
   /// <summary>
   ///   Cayman Islands (KY)
   /// </summary>
   KY = 116,
   /// <summary>
   ///   Kazakhstan (KZ)
   /// </summary>
   KZ = 117,
   /// <summary>
   ///   Laos (LA)
   /// </summary>
   LA = 118,
   /// <summary>
   ///   Lebanon (LB)
   /// </summary>
   LB = 119,
   /// <summary>
   ///   Saint Lucia (LC)
   /// </summary>
   LC = 120,
   /// <summary>
   ///   Liechtenstein (LI)
   /// </summary>
   LI = 121,
   /// <summary>
   ///   Sri Lanka (LK)
   /// </summary>
   LK = 122,
   /// <summary>
   ///   Liberia (LR)
   /// </summary>
   LR = 123,
   /// <summary>
   ///   Lesotho (LS)
   /// </summary>
   LS = 124,
   /// <summary>
   ///   Lithuania (LT)
   /// </summary>
   LT = 125,
   /// <summary>
   ///   Luxembourg (LU)
   /// </summary>
   LU = 126,
   /// <summary>
   ///   Latvia (LV)
   /// </summary>
   LV = 127,
   /// <summary>
   ///   Libya (LY)
   /// </summary>
   LY = 128,
   /// <summary>
   ///   Morocco (MA)
   /// </summary>
   MA = 129,
   /// <summary>
   ///   Monaco (MC)
   /// </summary>
   MC = 130,
   /// <summary>
   ///   Moldova (MD)
   /// </summary>
   MD = 131,
   /// <summary>
   ///   Madagascar (MG)
   /// </summary>
   MG = 132,
   /// <summary>
   ///   Marshall Islands (MH)
   /// </summary>
   MH = 133,
   /// <summary>
   ///   Macedonia (MK)
   /// </summary>
   MK = 134,
   /// <summary>
   ///   Mali (ML)
   /// </summary>
   ML = 135,
   /// <summary>
   ///   Burma (MM)
   /// </summary>
   MM = 136,
   /// <summary>
   ///   Mongolia (MN)
   /// </summary>
   MN = 137,
   /// <summary>
   ///   Macau (MO)
   /// </summary>
   MO = 138,
   /// <summary>
   ///   Northern Mariana Islands (MP)
   /// </summary>
   MP = 139,
   /// <summary>
   ///   Martinique (MQ)
   /// </summary>
   MQ = 140,
   /// <summary>
   ///   Mauritania (MR)
   /// </summary>
   MR = 141,
   /// <summary>
   ///   Montserrat (MS)
   /// </summary>
   MS = 142,
   /// <summary>
   ///   Malta (MT)
   /// </summary>
   MT = 143,
   /// <summary>
   ///   Mauritius (MU)
   /// </summary>
   MU = 144,
   /// <summary>
   ///   Maldives (MV)
   /// </summary>
   MV = 145,
   /// <summary>
   ///   Malawi (MW)
   /// </summary>
   MW = 146,
   /// <summary>
   ///   Mexico (MX)
   /// </summary>
   MX = 147,
   /// <summary>
   ///   Malaysia (MY)
   /// </summary>
   MY = 148,
   /// <summary>
   ///   Mozambique (MZ)
   /// </summary>
   MZ = 149,
   /// <summary>
   ///   Namibia (NA)
   /// </summary>
   NA = 150,
   /// <summary>
   ///   New Caledonia (NC)
   /// </summary>
   NC = 151,
   /// <summary>
   ///   Niger (NE)
   /// </summary>
   NE = 152,
   /// <summary>
   ///   Norfolk Island (NF)
   /// </summary>
   NF = 153,
   /// <summary>
   ///   Nigeria (NG)
   /// </summary>
   NG = 154,
   /// <summary>
   ///   Nicaragua (NI)
   /// </summary>
   NI = 155,
   /// <summary>
   ///   Netherlands (NL)
   /// </summary>
   NL = 156,
   /// <summary>
   ///   Norway (NO)
   /// </summary>
   NO = 157,
   /// <summary>
   ///   Nepal (NP)
   /// </summary>
   NP = 158,
   /// <summary>
   ///   Nauru (NR)
   /// </summary>
   NR = 159,
   /// <summary>
   ///   Niue (NU)
   /// </summary>
   NU = 160,
   /// <summary>
   ///   New Zealand (NZ)
   /// </summary>
   NZ = 161,
   /// <summary>
   ///   Oman (OM)
   /// </summary>
   OM = 162,
   /// <summary>
   ///   Panama (PA)
   /// </summary>
   PA = 163,
   /// <summary>
   ///   Peru (PE)
   /// </summary>
   PE = 164,
   /// <summary>
   ///   French Polynesia (PF)
   /// </summary>
   PF = 165,
   /// <summary>
   ///   Papua New Guinea (PG)
   /// </summary>
   PG = 166,
   /// <summary>
   ///   Philippines (PH)
   /// </summary>
   PH = 167,
   /// <summary>
   ///   Pakistan (PK)
   /// </summary>
   PK = 168,
   /// <summary>
   ///   Poland (PL)
   /// </summary>
   PL = 169,
   /// <summary>
   ///   Saint Pierre And Miquelon (PM)
   /// </summary>
   PM = 170,
   /// <summary>
   ///   Pitcairn Islands (PN)
   /// </summary>
   PN = 171,
   /// <summary>
   ///   Puerto Rico (PR)
   /// </summary>
   PR = 172,
   /// <summary>
   ///   Portugal (PT)
   /// </summary>
   PT = 173,
   /// <summary>
   ///   Palau (PW)
   /// </summary>
   PW = 174,
   /// <summary>
   ///   Paraguay (PY)
   /// </summary>
   PY = 175,
   /// <summary>
   ///   Qatar (QA)
   /// </summary>
   QA = 176,
   /// <summary>
   ///   Reunion (RE)
   /// </summary>
   RE = 177,
   /// <summary>
   ///   Romania (RO)
   /// </summary>
   RO = 178,
   /// <summary>
   ///   Russia (RU)
   /// </summary>
   RU = 179,
   /// <summary>
   ///   Rwanda (RW)
   /// </summary>
   RW = 180,
   /// <summary>
   ///   Saudi Arabia (SA)
   /// </summary>
   SA = 181,
   /// <summary>
   ///   Solomon Islands (SB)
   /// </summary>
   SB = 182,
   /// <summary>
   ///   Seychelles (SC)
   /// </summary>
   SC = 183,
   /// <summary>
   ///   Sudan (SD)
   /// </summary>
   SD = 184,
   /// <summary>
   ///   Sweden (SE)
   /// </summary>
   SE = 185,
   /// <summary>
   ///   Singapore (SG)
   /// </summary>
   SG = 186,
   /// <summary>
   ///   St. Helena (SH)
   /// </summary>
   SH = 187,
   /// <summary>
   ///   Slovenia (SI)
   /// </summary>
   SI = 188,
   /// <summary>
   ///   Svalbard (SJ)
   /// </summary>
   SJ = 189,
   /// <summary>
   ///   Slovakia (SK)
   /// </summary>
   SK = 190,
   /// <summary>
   ///   Sierra Leone (SL)
   /// </summary>
   SL = 191,
   /// <summary>
   ///   San Marino (SM)
   /// </summary>
   SM = 192,
   /// <summary>
   ///   Senegal (SN)
   /// </summary>
   SN = 193,
   /// <summary>
   ///   Somalia (SO)
   /// </summary>
   SO = 194,
   /// <summary>
   ///   Suriname (SR)
   /// </summary>
   SR = 195,
   /// <summary>
   ///   Sao Tome And Principe (ST)
   /// </summary>
   ST = 196,
   /// <summary>
   ///   Exception Country (XX)
   /// </summary>
   XX = 197,
   /// <summary>
   ///   El Salvador (SV)
   /// </summary>
   SV = 198,
   /// <summary>
   ///   Syria (SY)
   /// </summary>
   SY = 199,
   /// <summary>
   ///   Swaziland (SZ)
   /// </summary>
   SZ = 200,
   /// <summary>
   ///   Turks And Caicos Islands (TC)
   /// </summary>
   TC = 201,
   /// <summary>
   ///   Chad (TD)
   /// </summary>
   TD = 202,
   /// <summary>
   ///   Togo (TG)
   /// </summary>
   TG = 203,
   /// <summary>
   ///   Thailand (TH)
   /// </summary>
   TH = 204,
   /// <summary>
   ///   Tajikistan (TJ)
   /// </summary>
   TJ = 205,
   /// <summary>
   ///   Tokelau (TK)
   /// </summary>
   TK = 206,
   /// <summary>
   ///   Turkmenistan (TM)
   /// </summary>
   TM = 207,
   /// <summary>
   ///   Tunisia (TN)
   /// </summary>
   TN = 208,
   /// <summary>
   ///   Tonga (TO)
   /// </summary>
   TO = 209,
   /// <summary>
   ///   Timor-Leste (TL)
   /// </summary>
   TL = 210,
   /// <summary>
   ///   Turkey (TR)
   /// </summary>
   TR = 211,
   /// <summary>
   ///   Trinidad And Tobago (TT)
   /// </summary>
   TT = 212,
   /// <summary>
   ///   Tuvalu (TV)
   /// </summary>
   TV = 213,
   /// <summary>
   ///   Taiwan (TW)
   /// </summary>
   TW = 214,
   /// <summary>
   ///   Tanzania (TZ)
   /// </summary>
   TZ = 215,
   /// <summary>
   ///   Ukraine (UA)
   /// </summary>
   UA = 216,
   /// <summary>
   ///   Uganda (UG)
   /// </summary>
   UG = 217,
   /// <summary>
   ///   Minor Outlying Islands (US) (UM)
   /// </summary>
   UM = 218,
   /// <summary>
   ///   United States (US)
   /// </summary>
   US = 219,
   /// <summary>
   ///   Uruguay (UY)
   /// </summary>
   UY = 220,
   /// <summary>
   ///   Uzbekistan (UZ)
   /// </summary>
   UZ = 221,
   /// <summary>
   ///   Vatican City (VA)
   /// </summary>
   VA = 222,
   /// <summary>
   ///   Saint Vincent And The Grenadines (VC)
   /// </summary>
   VC = 223,
   /// <summary>
   ///   Venezuela (VE)
   /// </summary>
   VE = 224,
   /// <summary>
   ///   Virgin Islands, British (VG)
   /// </summary>
   VG = 225,
   /// <summary>
   ///   Virgin Islands, U.S. (VI)
   /// </summary>
   VI = 226,
   /// <summary>
   ///   Vietnam (VN)
   /// </summary>
   VN = 227,
   /// <summary>
   ///   Vanuatu (VU)
   /// </summary>
   VU = 228,
   /// <summary>
   ///   Wallis And Futuna (WF)
   /// </summary>
   WF = 229,
   /// <summary>
   ///   Samoa (WS)
   /// </summary>
   WS = 230,
   /// <summary>
   ///   Yemen (YE)
   /// </summary>
   YE = 231,
   /// <summary>
   ///   Mayotte (YT)
   /// </summary>
   YT = 232,
   /// <summary>
   ///   Yugoslavia (YU)
   /// </summary>
   YU = 233,
   /// <summary>
   ///   South Africa (ZA)
   /// </summary>
   ZA = 234,
   /// <summary>
   ///   Zambia (ZM)
   /// </summary>
   ZM = 235,
   /// <summary>
   ///   Congo (Kinshasa) (Zaire) (CD)
   /// </summary>
   CD = 236,
   /// <summary>
   ///   Zimbabwe (ZW)
   /// </summary>
   ZW = 237,
   /// <summary>
   ///   Serbia (RS)
   /// </summary>
   RS = 239,
   /// <summary>
   ///   Kosovo (KV)
   /// </summary>
   KV = 240,
   /// <summary>
   ///   West Bank (WE)
   /// </summary>
   WE = 241,
   /// <summary>
   ///   Sint Maarten (SX)
   /// </summary>
   SX = 242,
   /// <summary>
   ///   Serbia (prior to 2001) (CS)
   /// </summary>
   CS = 243,
   /// <summary>
   ///   Jersey (JE)
   /// </summary>
   JE = 244,
   /// <summary>
   ///   Baker Island (FQ)
   /// </summary>
   FQ = 245,
   /// <summary>
   ///   Howland Island (HQ)
   /// </summary>
   HQ = 246,
   /// <summary>
   ///   Jarvis Island (DQ)
   /// </summary>
   DQ = 247,
   /// <summary>
   ///   Johnston Atoll (JQ)
   /// </summary>
   JQ = 248,
   /// <summary>
   ///   Kingman Reef (KQ)
   /// </summary>
   KQ = 249,
   /// <summary>
   ///   Midway Islands (MI)
   /// </summary>
   MI = 250,
   /// <summary>
   ///   Navassa Island (BQ)
   /// </summary>
   BQ = 251,
   /// <summary>
   ///   Palmyra Atoll (LQ)
   /// </summary>
   LQ = 252,
   /// <summary>
   ///   Wake Island (WQ)
   /// </summary>
   WQ = 253,
   /// <summary>
   ///   Ashmore And Cartier Islands (AH)
   /// </summary>
   AH = 254,
   /// <summary>
   ///   Bassas Da India (BX)
   /// </summary>
   BX = 255,
   /// <summary>
   ///   Clipperton Island (CP)
   /// </summary>
   CP = 256,
   /// <summary>
   ///   Coral Sea Islands (CQ)
   /// </summary>
   CQ = 257,
   /// <summary>
   ///   Europa Island (EU)
   /// </summary>
   EU = 258,
   /// <summary>
   ///   French Southern, Antartic Lands (TF)
   /// </summary>
   TF = 259,
   /// <summary>
   ///   Gaza Strip (GZ)
   /// </summary>
   GZ = 260,
   /// <summary>
   ///   Glorioso Islands (GO)
   /// </summary>
   GO = 261,
   /// <summary>
   ///   Guernsey (GG)
   /// </summary>
   GG = 262,
   /// <summary>
   ///   Isle Of Man (IM)
   /// </summary>
   IM = 263,
   /// <summary>
   ///   Juan De Nova Island (JU)
   /// </summary>
   JU = 264,
   /// <summary>
   ///   Montenegro (ME)
   /// </summary>
   ME = 265,
   /// <summary>
   ///   Paracel Islands (PX)
   /// </summary>
   PX = 266,
   /// <summary>
   ///   Saint Barthelemy (BL)
   /// </summary>
   BL = 267,
   /// <summary>
   ///   Saint Martin (MF)
   /// </summary>
   MF = 268,
   /// <summary>
   ///   Spratly Islands (XG)
   /// </summary>
   XG = 269,
   /// <summary>
   ///   Tromelin Island (TE)
   /// </summary>
   TE = 270,
   /// <summary>
   ///   Western Sahara (EH)
   /// </summary>
   EH = 271
}

export const Countries: Country[] = [
   {
      code: Country_.Unknown,
      literal: 'Unknown',
      description: '',
      shortDescription: '',
      listPriority: 0,

      standardCode: '  ',

      name: ' ',

      isRelevant: true,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AD,
      literal: 'AD',
      description: 'Andorra',
      shortDescription: 'AD',
      listPriority: 255,

      standardCode: 'AD',

      name: 'Andorra',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AE,
      literal: 'AE',
      description: 'United Arab Emirates',
      shortDescription: 'AE',
      listPriority: 255,

      standardCode: 'AE',

      name: 'United Arab Emirates',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AF,
      literal: 'AF',
      description: 'Afghanistan',
      shortDescription: 'AF',
      listPriority: 255,

      standardCode: 'AF',

      name: 'Afghanistan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AG,
      literal: 'AG',
      description: 'Antigua and Barbuda',
      shortDescription: 'AG',
      listPriority: 255,

      standardCode: 'AG',

      name: 'Antigua and Barbuda',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AI,
      literal: 'AI',
      description: 'Anguilla',
      shortDescription: 'AI',
      listPriority: 255,

      standardCode: 'AI',

      name: 'Anguilla',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AL,
      literal: 'AL',
      description: 'Albania',
      shortDescription: 'AL',
      listPriority: 255,

      standardCode: 'AL',

      name: 'Albania',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AM,
      literal: 'AM',
      description: 'Armenia',
      shortDescription: 'AM',
      listPriority: 255,

      standardCode: 'AM',

      name: 'Armenia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AN,
      literal: 'AN',
      description: 'Dutch Antilles',
      shortDescription: 'AN',
      listPriority: 255,

      standardCode: 'AN',

      name: 'Dutch Antilles',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AO,
      literal: 'AO',
      description: 'Angola',
      shortDescription: 'AO',
      listPriority: 255,

      standardCode: 'AO',

      name: 'Angola',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AQ,
      literal: 'AQ',
      description: 'Antarctica',
      shortDescription: 'AQ',
      listPriority: 255,

      standardCode: 'AQ',

      name: 'Antarctica',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AR,
      literal: 'AR',
      description: 'Argentina',
      shortDescription: 'AR',
      listPriority: 255,

      standardCode: 'AR',

      name: 'Argentina',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AS,
      literal: 'AS',
      description: 'American Samoa',
      shortDescription: 'AS',
      listPriority: 255,

      standardCode: 'AS',

      name: 'American Samoa',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AT,
      literal: 'AT',
      description: 'Austria',
      shortDescription: 'AT',
      listPriority: 255,

      standardCode: 'AT',

      name: 'Austria',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AU,
      literal: 'AU',
      description: 'Australia',
      shortDescription: 'AU',
      listPriority: 255,

      standardCode: 'AU',

      name: 'Australia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AW,
      literal: 'AW',
      description: 'Aruba',
      shortDescription: 'AW',
      listPriority: 255,

      standardCode: 'AW',

      name: 'Aruba',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AZ,
      literal: 'AZ',
      description: 'Azerbaijan',
      shortDescription: 'AZ',
      listPriority: 255,

      standardCode: 'AZ',

      name: 'Azerbaijan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BA,
      literal: 'BA',
      description: 'Bosnia and Herzegovina',
      shortDescription: 'BA',
      listPriority: 255,

      standardCode: 'BA',

      name: 'Bosnia and Herzegovina',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BB,
      literal: 'BB',
      description: 'Barbados',
      shortDescription: 'BB',
      listPriority: 255,

      standardCode: 'BB',

      name: 'Barbados',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BD,
      literal: 'BD',
      description: 'Bangladesh',
      shortDescription: 'BD',
      listPriority: 255,

      standardCode: 'BD',

      name: 'Bangladesh',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BE,
      literal: 'BE',
      description: 'Belgium',
      shortDescription: 'BE',
      listPriority: 255,

      standardCode: 'BE',

      name: 'Belgium',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BF,
      literal: 'BF',
      description: 'Burkina Faso',
      shortDescription: 'BF',
      listPriority: 255,

      standardCode: 'BF',

      name: 'Burkina Faso',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BG,
      literal: 'BG',
      description: 'Bulgaria',
      shortDescription: 'BG',
      listPriority: 255,

      standardCode: 'BG',

      name: 'Bulgaria',

      isRelevant: true,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BH,
      literal: 'BH',
      description: 'Bahrain',
      shortDescription: 'BH',
      listPriority: 255,

      standardCode: 'BH',

      name: 'Bahrain',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BI,
      literal: 'BI',
      description: 'Burundi',
      shortDescription: 'BI',
      listPriority: 255,

      standardCode: 'BI',

      name: 'Burundi',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BJ,
      literal: 'BJ',
      description: 'Benin',
      shortDescription: 'BJ',
      listPriority: 255,

      standardCode: 'BJ',

      name: 'Benin',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BM,
      literal: 'BM',
      description: 'Bermuda',
      shortDescription: 'BM',
      listPriority: 255,

      standardCode: 'BM',

      name: 'Bermuda',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BN,
      literal: 'BN',
      description: 'Brunei',
      shortDescription: 'BN',
      listPriority: 255,

      standardCode: 'BN',

      name: 'Brunei',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BO,
      literal: 'BO',
      description: 'Bolivia',
      shortDescription: 'BO',
      listPriority: 255,

      standardCode: 'BO',

      name: 'Bolivia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BR,
      literal: 'BR',
      description: 'Brazil',
      shortDescription: 'BR',
      listPriority: 255,

      standardCode: 'BR',

      name: 'Brazil',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BS,
      literal: 'BS',
      description: 'Bahamas, The',
      shortDescription: 'BS',
      listPriority: 255,

      standardCode: 'BS',

      name: 'Bahamas, The',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BT,
      literal: 'BT',
      description: 'Bhutan',
      shortDescription: 'BT',
      listPriority: 255,

      standardCode: 'BT',

      name: 'Bhutan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BV,
      literal: 'BV',
      description: 'Bouvet Island',
      shortDescription: 'BV',
      listPriority: 255,

      standardCode: 'BV',

      name: 'Bouvet Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BW,
      literal: 'BW',
      description: 'Botswana',
      shortDescription: 'BW',
      listPriority: 255,

      standardCode: 'BW',

      name: 'Botswana',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BY,
      literal: 'BY',
      description: 'Belarus',
      shortDescription: 'BY',
      listPriority: 255,

      standardCode: 'BY',

      name: 'Belarus',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BZ,
      literal: 'BZ',
      description: 'Belize',
      shortDescription: 'BZ',
      listPriority: 255,

      standardCode: 'BZ',

      name: 'Belize',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CA,
      literal: 'CA',
      description: 'Canada',
      shortDescription: 'CA',
      listPriority: 1,

      standardCode: 'CA',

      name: 'Canada',

      isRelevant: true,

      effectiveCurrencyCode: 2,

      addressVerificationEnabled: true,

      isTextMessagingSupported: true,

      typeName: "Country"
   },
   {
      code: Country_.CC,
      literal: 'CC',
      description: 'Cocos (Keeling) Islands',
      shortDescription: 'CC',
      listPriority: 255,

      standardCode: 'CC',

      name: 'Cocos (Keeling) Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CF,
      literal: 'CF',
      description: 'Central African Republic',
      shortDescription: 'CF',
      listPriority: 255,

      standardCode: 'CF',

      name: 'Central African Republic',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CG,
      literal: 'CG',
      description: 'Congo (Brazzaville)',
      shortDescription: 'CG',
      listPriority: 255,

      standardCode: 'CG',

      name: 'Congo (Brazzaville)',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CH,
      literal: 'CH',
      description: 'Switzerland',
      shortDescription: 'CH',
      listPriority: 255,

      standardCode: 'CH',

      name: 'Switzerland',

      isRelevant: true,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CI,
      literal: 'CI',
      description: 'Cote D\'Ivoire',
      shortDescription: 'CI',
      listPriority: 255,

      standardCode: 'CI',

      name: 'Cote D\'Ivoire',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CK,
      literal: 'CK',
      description: 'Cook Islands',
      shortDescription: 'CK',
      listPriority: 255,

      standardCode: 'CK',

      name: 'Cook Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CL,
      literal: 'CL',
      description: 'Chile',
      shortDescription: 'CL',
      listPriority: 255,

      standardCode: 'CL',

      name: 'Chile',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CM,
      literal: 'CM',
      description: 'Cameroon',
      shortDescription: 'CM',
      listPriority: 255,

      standardCode: 'CM',

      name: 'Cameroon',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CN,
      literal: 'CN',
      description: 'China',
      shortDescription: 'CN',
      listPriority: 255,

      standardCode: 'CN',

      name: 'China',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CO,
      literal: 'CO',
      description: 'Colombia',
      shortDescription: 'CO',
      listPriority: 255,

      standardCode: 'CO',

      name: 'Colombia',

      isRelevant: true,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CR,
      literal: 'CR',
      description: 'Costa Rica',
      shortDescription: 'CR',
      listPriority: 255,

      standardCode: 'CR',

      name: 'Costa Rica',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CU,
      literal: 'CU',
      description: 'Cuba',
      shortDescription: 'CU',
      listPriority: 255,

      standardCode: 'CU',

      name: 'Cuba',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CV,
      literal: 'CV',
      description: 'Cabo Verde',
      shortDescription: 'CV',
      listPriority: 255,

      standardCode: 'CV',

      name: 'Cabo Verde',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CX,
      literal: 'CX',
      description: 'Christmas Island',
      shortDescription: 'CX',
      listPriority: 255,

      standardCode: 'CX',

      name: 'Christmas Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CY,
      literal: 'CY',
      description: 'Cyprus',
      shortDescription: 'CY',
      listPriority: 255,

      standardCode: 'CY',

      name: 'Cyprus',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CZ,
      literal: 'CZ',
      description: 'Czech Republic',
      shortDescription: 'CZ',
      listPriority: 255,

      standardCode: 'CZ',

      name: 'Czech Republic',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DE,
      literal: 'DE',
      description: 'Germany',
      shortDescription: 'DE',
      listPriority: 255,

      standardCode: 'DE',

      name: 'Germany',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DJ,
      literal: 'DJ',
      description: 'Djibouti',
      shortDescription: 'DJ',
      listPriority: 255,

      standardCode: 'DJ',

      name: 'Djibouti',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DK,
      literal: 'DK',
      description: 'Denmark',
      shortDescription: 'DK',
      listPriority: 255,

      standardCode: 'DK',

      name: 'Denmark',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DM,
      literal: 'DM',
      description: 'Dominica',
      shortDescription: 'DM',
      listPriority: 255,

      standardCode: 'DM',

      name: 'Dominica',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DO,
      literal: 'DO',
      description: 'Dominican Republic',
      shortDescription: 'DO',
      listPriority: 255,

      standardCode: 'DO',

      name: 'Dominican Republic',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DZ,
      literal: 'DZ',
      description: 'Algeria',
      shortDescription: 'DZ',
      listPriority: 255,

      standardCode: 'DZ',

      name: 'Algeria',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.EC,
      literal: 'EC',
      description: 'Ecuador',
      shortDescription: 'EC',
      listPriority: 255,

      standardCode: 'EC',

      name: 'Ecuador',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.EE,
      literal: 'EE',
      description: 'Estonia',
      shortDescription: 'EE',
      listPriority: 255,

      standardCode: 'EE',

      name: 'Estonia',

      isRelevant: true,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.EG,
      literal: 'EG',
      description: 'Egypt',
      shortDescription: 'EG',
      listPriority: 255,

      standardCode: 'EG',

      name: 'Egypt',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ER,
      literal: 'ER',
      description: 'Eritrea',
      shortDescription: 'ER',
      listPriority: 255,

      standardCode: 'ER',

      name: 'Eritrea',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ES,
      literal: 'ES',
      description: 'Spain',
      shortDescription: 'ES',
      listPriority: 255,

      standardCode: 'ES',

      name: 'Spain',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ET,
      literal: 'ET',
      description: 'Ethiopia',
      shortDescription: 'ET',
      listPriority: 255,

      standardCode: 'ET',

      name: 'Ethiopia',

      isRelevant: true,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FI,
      literal: 'FI',
      description: 'Finland',
      shortDescription: 'FI',
      listPriority: 255,

      standardCode: 'FI',

      name: 'Finland',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FJ,
      literal: 'FJ',
      description: 'Fiji',
      shortDescription: 'FJ',
      listPriority: 255,

      standardCode: 'FJ',

      name: 'Fiji',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FK,
      literal: 'FK',
      description: 'Falkland Islands',
      shortDescription: 'FK',
      listPriority: 255,

      standardCode: 'FK',

      name: 'Falkland Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FM,
      literal: 'FM',
      description: 'Micronesia, Federated States Of',
      shortDescription: 'FM',
      listPriority: 255,

      standardCode: 'FM',

      name: 'Micronesia, Federated States Of',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FO,
      literal: 'FO',
      description: 'Faroe Islands',
      shortDescription: 'FO',
      listPriority: 255,

      standardCode: 'FO',

      name: 'Faroe Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FR,
      literal: 'FR',
      description: 'France',
      shortDescription: 'FR',
      listPriority: 255,

      standardCode: 'FR',

      name: 'France',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GA,
      literal: 'GA',
      description: 'Gabon',
      shortDescription: 'GA',
      listPriority: 255,

      standardCode: 'GA',

      name: 'Gabon',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GB,
      literal: 'GB',
      description: 'United Kingdom',
      shortDescription: 'GB',
      listPriority: 2,

      standardCode: 'GB',

      name: 'United Kingdom',

      isRelevant: true,

      effectiveCurrencyCode: 3,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GD,
      literal: 'GD',
      description: 'Grenada',
      shortDescription: 'GD',
      listPriority: 255,

      standardCode: 'GD',

      name: 'Grenada',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GE,
      literal: 'GE',
      description: 'Georgia',
      shortDescription: 'GE',
      listPriority: 255,

      standardCode: 'GE',

      name: 'Georgia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GF,
      literal: 'GF',
      description: 'French Guiana',
      shortDescription: 'GF',
      listPriority: 255,

      standardCode: 'GF',

      name: 'French Guiana',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GH,
      literal: 'GH',
      description: 'Ghana',
      shortDescription: 'GH',
      listPriority: 255,

      standardCode: 'GH',

      name: 'Ghana',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GI,
      literal: 'GI',
      description: 'Gibraltar',
      shortDescription: 'GI',
      listPriority: 255,

      standardCode: 'GI',

      name: 'Gibraltar',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GL,
      literal: 'GL',
      description: 'Greenland',
      shortDescription: 'GL',
      listPriority: 255,

      standardCode: 'GL',

      name: 'Greenland',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GM,
      literal: 'GM',
      description: 'Gambia, The',
      shortDescription: 'GM',
      listPriority: 255,

      standardCode: 'GM',

      name: 'Gambia, The',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GN,
      literal: 'GN',
      description: 'Guinea',
      shortDescription: 'GN',
      listPriority: 255,

      standardCode: 'GN',

      name: 'Guinea',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GP,
      literal: 'GP',
      description: 'Guadeloupe',
      shortDescription: 'GP',
      listPriority: 255,

      standardCode: 'GP',

      name: 'Guadeloupe',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GQ,
      literal: 'GQ',
      description: 'Equatorial Guinea',
      shortDescription: 'GQ',
      listPriority: 255,

      standardCode: 'GQ',

      name: 'Equatorial Guinea',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GR,
      literal: 'GR',
      description: 'Greece',
      shortDescription: 'GR',
      listPriority: 255,

      standardCode: 'GR',

      name: 'Greece',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GS,
      literal: 'GS',
      description: 'S. Georgia, S. Sandwich Islands',
      shortDescription: 'GS',
      listPriority: 255,

      standardCode: 'GS',

      name: 'S. Georgia, S. Sandwich Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GT,
      literal: 'GT',
      description: 'Guatemala',
      shortDescription: 'GT',
      listPriority: 255,

      standardCode: 'GT',

      name: 'Guatemala',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GU,
      literal: 'GU',
      description: 'Guam',
      shortDescription: 'GU',
      listPriority: 255,

      standardCode: 'GU',

      name: 'Guam',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GW,
      literal: 'GW',
      description: 'Guinea-Bissau',
      shortDescription: 'GW',
      listPriority: 255,

      standardCode: 'GW',

      name: 'Guinea-Bissau',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GY,
      literal: 'GY',
      description: 'Guyana',
      shortDescription: 'GY',
      listPriority: 255,

      standardCode: 'GY',

      name: 'Guyana',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HK,
      literal: 'HK',
      description: 'Hong Kong',
      shortDescription: 'HK',
      listPriority: 255,

      standardCode: 'HK',

      name: 'Hong Kong',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HM,
      literal: 'HM',
      description: 'Heard Island, McDonald Islands',
      shortDescription: 'HM',
      listPriority: 255,

      standardCode: 'HM',

      name: 'Heard Island, McDonald Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HN,
      literal: 'HN',
      description: 'Honduras',
      shortDescription: 'HN',
      listPriority: 255,

      standardCode: 'HN',

      name: 'Honduras',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HR,
      literal: 'HR',
      description: 'Croatia',
      shortDescription: 'HR',
      listPriority: 255,

      standardCode: 'HR',

      name: 'Croatia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HT,
      literal: 'HT',
      description: 'Haiti',
      shortDescription: 'HT',
      listPriority: 255,

      standardCode: 'HT',

      name: 'Haiti',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HU,
      literal: 'HU',
      description: 'Hungary',
      shortDescription: 'HU',
      listPriority: 255,

      standardCode: 'HU',

      name: 'Hungary',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ID,
      literal: 'ID',
      description: 'Indonesia',
      shortDescription: 'ID',
      listPriority: 255,

      standardCode: 'ID',

      name: 'Indonesia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IE,
      literal: 'IE',
      description: 'Ireland',
      shortDescription: 'IE',
      listPriority: 255,

      standardCode: 'IE',

      name: 'Ireland',

      isRelevant: true,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IL,
      literal: 'IL',
      description: 'Israel',
      shortDescription: 'IL',
      listPriority: 255,

      standardCode: 'IL',

      name: 'Israel',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IN,
      literal: 'IN',
      description: 'India',
      shortDescription: 'IN',
      listPriority: 255,

      standardCode: 'IN',

      name: 'India',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IO,
      literal: 'IO',
      description: 'British Indian Ocean Territory',
      shortDescription: 'IO',
      listPriority: 255,

      standardCode: 'IO',

      name: 'British Indian Ocean Territory',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IQ,
      literal: 'IQ',
      description: 'Iraq',
      shortDescription: 'IQ',
      listPriority: 255,

      standardCode: 'IQ',

      name: 'Iraq',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IR,
      literal: 'IR',
      description: 'Iran',
      shortDescription: 'IR',
      listPriority: 255,

      standardCode: 'IR',

      name: 'Iran',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IS,
      literal: 'IS',
      description: 'Iceland',
      shortDescription: 'IS',
      listPriority: 255,

      standardCode: 'IS',

      name: 'Iceland',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IT,
      literal: 'IT',
      description: 'Italy',
      shortDescription: 'IT',
      listPriority: 255,

      standardCode: 'IT',

      name: 'Italy',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.JM,
      literal: 'JM',
      description: 'Jamaica',
      shortDescription: 'JM',
      listPriority: 255,

      standardCode: 'JM',

      name: 'Jamaica',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.JO,
      literal: 'JO',
      description: 'Jordan',
      shortDescription: 'JO',
      listPriority: 255,

      standardCode: 'JO',

      name: 'Jordan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.JP,
      literal: 'JP',
      description: 'Japan',
      shortDescription: 'JP',
      listPriority: 255,

      standardCode: 'JP',

      name: 'Japan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KE,
      literal: 'KE',
      description: 'Kenya',
      shortDescription: 'KE',
      listPriority: 255,

      standardCode: 'KE',

      name: 'Kenya',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KG,
      literal: 'KG',
      description: 'Kyrgyzstan',
      shortDescription: 'KG',
      listPriority: 255,

      standardCode: 'KG',

      name: 'Kyrgyzstan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KH,
      literal: 'KH',
      description: 'Cambodia',
      shortDescription: 'KH',
      listPriority: 255,

      standardCode: 'KH',

      name: 'Cambodia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KI,
      literal: 'KI',
      description: 'Kiribati',
      shortDescription: 'KI',
      listPriority: 255,

      standardCode: 'KI',

      name: 'Kiribati',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KM,
      literal: 'KM',
      description: 'Comoros',
      shortDescription: 'KM',
      listPriority: 255,

      standardCode: 'KM',

      name: 'Comoros',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KN,
      literal: 'KN',
      description: 'Saint Kitts And Nevis',
      shortDescription: 'KN',
      listPriority: 255,

      standardCode: 'KN',

      name: 'Saint Kitts And Nevis',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KP,
      literal: 'KP',
      description: 'Korea, North',
      shortDescription: 'KP',
      listPriority: 255,

      standardCode: 'KP',

      name: 'Korea, North',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KR,
      literal: 'KR',
      description: 'Korea, South',
      shortDescription: 'KR',
      listPriority: 255,

      standardCode: 'KR',

      name: 'Korea, South',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KW,
      literal: 'KW',
      description: 'Kuwait',
      shortDescription: 'KW',
      listPriority: 255,

      standardCode: 'KW',

      name: 'Kuwait',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KY,
      literal: 'KY',
      description: 'Cayman Islands',
      shortDescription: 'KY',
      listPriority: 255,

      standardCode: 'KY',

      name: 'Cayman Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KZ,
      literal: 'KZ',
      description: 'Kazakhstan',
      shortDescription: 'KZ',
      listPriority: 255,

      standardCode: 'KZ',

      name: 'Kazakhstan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LA,
      literal: 'LA',
      description: 'Laos',
      shortDescription: 'LA',
      listPriority: 255,

      standardCode: 'LA',

      name: 'Laos',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LB,
      literal: 'LB',
      description: 'Lebanon',
      shortDescription: 'LB',
      listPriority: 255,

      standardCode: 'LB',

      name: 'Lebanon',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LC,
      literal: 'LC',
      description: 'Saint Lucia',
      shortDescription: 'LC',
      listPriority: 255,

      standardCode: 'LC',

      name: 'Saint Lucia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LI,
      literal: 'LI',
      description: 'Liechtenstein',
      shortDescription: 'LI',
      listPriority: 255,

      standardCode: 'LI',

      name: 'Liechtenstein',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LK,
      literal: 'LK',
      description: 'Sri Lanka',
      shortDescription: 'LK',
      listPriority: 255,

      standardCode: 'LK',

      name: 'Sri Lanka',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LR,
      literal: 'LR',
      description: 'Liberia',
      shortDescription: 'LR',
      listPriority: 255,

      standardCode: 'LR',

      name: 'Liberia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LS,
      literal: 'LS',
      description: 'Lesotho',
      shortDescription: 'LS',
      listPriority: 255,

      standardCode: 'LS',

      name: 'Lesotho',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LT,
      literal: 'LT',
      description: 'Lithuania',
      shortDescription: 'LT',
      listPriority: 255,

      standardCode: 'LT',

      name: 'Lithuania',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LU,
      literal: 'LU',
      description: 'Luxembourg',
      shortDescription: 'LU',
      listPriority: 255,

      standardCode: 'LU',

      name: 'Luxembourg',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LV,
      literal: 'LV',
      description: 'Latvia',
      shortDescription: 'LV',
      listPriority: 255,

      standardCode: 'LV',

      name: 'Latvia',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LY,
      literal: 'LY',
      description: 'Libya',
      shortDescription: 'LY',
      listPriority: 255,

      standardCode: 'LY',

      name: 'Libya',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MA,
      literal: 'MA',
      description: 'Morocco',
      shortDescription: 'MA',
      listPriority: 255,

      standardCode: 'MA',

      name: 'Morocco',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MC,
      literal: 'MC',
      description: 'Monaco',
      shortDescription: 'MC',
      listPriority: 255,

      standardCode: 'MC',

      name: 'Monaco',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MD,
      literal: 'MD',
      description: 'Moldova',
      shortDescription: 'MD',
      listPriority: 255,

      standardCode: 'MD',

      name: 'Moldova',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MG,
      literal: 'MG',
      description: 'Madagascar',
      shortDescription: 'MG',
      listPriority: 255,

      standardCode: 'MG',

      name: 'Madagascar',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MH,
      literal: 'MH',
      description: 'Marshall Islands',
      shortDescription: 'MH',
      listPriority: 255,

      standardCode: 'MH',

      name: 'Marshall Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MK,
      literal: 'MK',
      description: 'Macedonia',
      shortDescription: 'MK',
      listPriority: 255,

      standardCode: 'MK',

      name: 'Macedonia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ML,
      literal: 'ML',
      description: 'Mali',
      shortDescription: 'ML',
      listPriority: 255,

      standardCode: 'ML',

      name: 'Mali',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MM,
      literal: 'MM',
      description: 'Burma',
      shortDescription: 'MM',
      listPriority: 255,

      standardCode: 'MM',

      name: 'Burma',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MN,
      literal: 'MN',
      description: 'Mongolia',
      shortDescription: 'MN',
      listPriority: 255,

      standardCode: 'MN',

      name: 'Mongolia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MO,
      literal: 'MO',
      description: 'Macau',
      shortDescription: 'MO',
      listPriority: 255,

      standardCode: 'MO',

      name: 'Macau',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MP,
      literal: 'MP',
      description: 'Northern Mariana Islands',
      shortDescription: 'MP',
      listPriority: 255,

      standardCode: 'MP',

      name: 'Northern Mariana Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MQ,
      literal: 'MQ',
      description: 'Martinique',
      shortDescription: 'MQ',
      listPriority: 255,

      standardCode: 'MQ',

      name: 'Martinique',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MR,
      literal: 'MR',
      description: 'Mauritania',
      shortDescription: 'MR',
      listPriority: 255,

      standardCode: 'MR',

      name: 'Mauritania',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MS,
      literal: 'MS',
      description: 'Montserrat',
      shortDescription: 'MS',
      listPriority: 255,

      standardCode: 'MS',

      name: 'Montserrat',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MT,
      literal: 'MT',
      description: 'Malta',
      shortDescription: 'MT',
      listPriority: 255,

      standardCode: 'MT',

      name: 'Malta',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MU,
      literal: 'MU',
      description: 'Mauritius',
      shortDescription: 'MU',
      listPriority: 255,

      standardCode: 'MU',

      name: 'Mauritius',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MV,
      literal: 'MV',
      description: 'Maldives',
      shortDescription: 'MV',
      listPriority: 255,

      standardCode: 'MV',

      name: 'Maldives',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MW,
      literal: 'MW',
      description: 'Malawi',
      shortDescription: 'MW',
      listPriority: 255,

      standardCode: 'MW',

      name: 'Malawi',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MX,
      literal: 'MX',
      description: 'Mexico',
      shortDescription: 'MX',
      listPriority: 255,

      standardCode: 'MX',

      name: 'Mexico',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MY,
      literal: 'MY',
      description: 'Malaysia',
      shortDescription: 'MY',
      listPriority: 255,

      standardCode: 'MY',

      name: 'Malaysia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MZ,
      literal: 'MZ',
      description: 'Mozambique',
      shortDescription: 'MZ',
      listPriority: 255,

      standardCode: 'MZ',

      name: 'Mozambique',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NA,
      literal: 'NA',
      description: 'Namibia',
      shortDescription: 'NA',
      listPriority: 255,

      standardCode: 'NA',

      name: 'Namibia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NC,
      literal: 'NC',
      description: 'New Caledonia',
      shortDescription: 'NC',
      listPriority: 255,

      standardCode: 'NC',

      name: 'New Caledonia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NE,
      literal: 'NE',
      description: 'Niger',
      shortDescription: 'NE',
      listPriority: 255,

      standardCode: 'NE',

      name: 'Niger',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NF,
      literal: 'NF',
      description: 'Norfolk Island',
      shortDescription: 'NF',
      listPriority: 255,

      standardCode: 'NF',

      name: 'Norfolk Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NG,
      literal: 'NG',
      description: 'Nigeria',
      shortDescription: 'NG',
      listPriority: 255,

      standardCode: 'NG',

      name: 'Nigeria',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NI,
      literal: 'NI',
      description: 'Nicaragua',
      shortDescription: 'NI',
      listPriority: 255,

      standardCode: 'NI',

      name: 'Nicaragua',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NL,
      literal: 'NL',
      description: 'Netherlands',
      shortDescription: 'NL',
      listPriority: 255,

      standardCode: 'NL',

      name: 'Netherlands',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NO,
      literal: 'NO',
      description: 'Norway',
      shortDescription: 'NO',
      listPriority: 255,

      standardCode: 'NO',

      name: 'Norway',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NP,
      literal: 'NP',
      description: 'Nepal',
      shortDescription: 'NP',
      listPriority: 255,

      standardCode: 'NP',

      name: 'Nepal',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NR,
      literal: 'NR',
      description: 'Nauru',
      shortDescription: 'NR',
      listPriority: 255,

      standardCode: 'NR',

      name: 'Nauru',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NU,
      literal: 'NU',
      description: 'Niue',
      shortDescription: 'NU',
      listPriority: 255,

      standardCode: 'NU',

      name: 'Niue',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.NZ,
      literal: 'NZ',
      description: 'New Zealand',
      shortDescription: 'NZ',
      listPriority: 255,

      standardCode: 'NZ',

      name: 'New Zealand',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.OM,
      literal: 'OM',
      description: 'Oman',
      shortDescription: 'OM',
      listPriority: 255,

      standardCode: 'OM',

      name: 'Oman',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PA,
      literal: 'PA',
      description: 'Panama',
      shortDescription: 'PA',
      listPriority: 255,

      standardCode: 'PA',

      name: 'Panama',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PE,
      literal: 'PE',
      description: 'Peru',
      shortDescription: 'PE',
      listPriority: 255,

      standardCode: 'PE',

      name: 'Peru',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PF,
      literal: 'PF',
      description: 'French Polynesia',
      shortDescription: 'PF',
      listPriority: 255,

      standardCode: 'PF',

      name: 'French Polynesia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PG,
      literal: 'PG',
      description: 'Papua New Guinea',
      shortDescription: 'PG',
      listPriority: 255,

      standardCode: 'PG',

      name: 'Papua New Guinea',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PH,
      literal: 'PH',
      description: 'Philippines',
      shortDescription: 'PH',
      listPriority: 255,

      standardCode: 'PH',

      name: 'Philippines',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PK,
      literal: 'PK',
      description: 'Pakistan',
      shortDescription: 'PK',
      listPriority: 255,

      standardCode: 'PK',

      name: 'Pakistan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PL,
      literal: 'PL',
      description: 'Poland',
      shortDescription: 'PL',
      listPriority: 255,

      standardCode: 'PL',

      name: 'Poland',

      isRelevant: true,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PM,
      literal: 'PM',
      description: 'Saint Pierre And Miquelon',
      shortDescription: 'PM',
      listPriority: 255,

      standardCode: 'PM',

      name: 'Saint Pierre And Miquelon',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PN,
      literal: 'PN',
      description: 'Pitcairn Islands',
      shortDescription: 'PN',
      listPriority: 255,

      standardCode: 'PN',

      name: 'Pitcairn Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PR,
      literal: 'PR',
      description: 'Puerto Rico',
      shortDescription: 'PR',
      listPriority: 255,

      standardCode: 'PR',

      name: 'Puerto Rico',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PT,
      literal: 'PT',
      description: 'Portugal',
      shortDescription: 'PT',
      listPriority: 255,

      standardCode: 'PT',

      name: 'Portugal',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PW,
      literal: 'PW',
      description: 'Palau',
      shortDescription: 'PW',
      listPriority: 255,

      standardCode: 'PW',

      name: 'Palau',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PY,
      literal: 'PY',
      description: 'Paraguay',
      shortDescription: 'PY',
      listPriority: 255,

      standardCode: 'PY',

      name: 'Paraguay',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.QA,
      literal: 'QA',
      description: 'Qatar',
      shortDescription: 'QA',
      listPriority: 255,

      standardCode: 'QA',

      name: 'Qatar',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.RE,
      literal: 'RE',
      description: 'Reunion',
      shortDescription: 'RE',
      listPriority: 255,

      standardCode: 'RE',

      name: 'Reunion',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.RO,
      literal: 'RO',
      description: 'Romania',
      shortDescription: 'RO',
      listPriority: 255,

      standardCode: 'RO',

      name: 'Romania',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.RU,
      literal: 'RU',
      description: 'Russia',
      shortDescription: 'RU',
      listPriority: 255,

      standardCode: 'RU',

      name: 'Russia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.RW,
      literal: 'RW',
      description: 'Rwanda',
      shortDescription: 'RW',
      listPriority: 255,

      standardCode: 'RW',

      name: 'Rwanda',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SA,
      literal: 'SA',
      description: 'Saudi Arabia',
      shortDescription: 'SA',
      listPriority: 255,

      standardCode: 'SA',

      name: 'Saudi Arabia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SB,
      literal: 'SB',
      description: 'Solomon Islands',
      shortDescription: 'SB',
      listPriority: 255,

      standardCode: 'SB',

      name: 'Solomon Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SC,
      literal: 'SC',
      description: 'Seychelles',
      shortDescription: 'SC',
      listPriority: 255,

      standardCode: 'SC',

      name: 'Seychelles',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SD,
      literal: 'SD',
      description: 'Sudan',
      shortDescription: 'SD',
      listPriority: 255,

      standardCode: 'SD',

      name: 'Sudan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SE,
      literal: 'SE',
      description: 'Sweden',
      shortDescription: 'SE',
      listPriority: 255,

      standardCode: 'SE',

      name: 'Sweden',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SG,
      literal: 'SG',
      description: 'Singapore',
      shortDescription: 'SG',
      listPriority: 255,

      standardCode: 'SG',

      name: 'Singapore',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SH,
      literal: 'SH',
      description: 'St. Helena',
      shortDescription: 'SH',
      listPriority: 255,

      standardCode: 'SH',

      name: 'St. Helena',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SI,
      literal: 'SI',
      description: 'Slovenia',
      shortDescription: 'SI',
      listPriority: 255,

      standardCode: 'SI',

      name: 'Slovenia',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SJ,
      literal: 'SJ',
      description: 'Svalbard',
      shortDescription: 'SJ',
      listPriority: 255,

      standardCode: 'SJ',

      name: 'Svalbard',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SK,
      literal: 'SK',
      description: 'Slovakia',
      shortDescription: 'SK',
      listPriority: 255,

      standardCode: 'SK',

      name: 'Slovakia',

      isRelevant: false,

      effectiveCurrencyCode: 4,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SL,
      literal: 'SL',
      description: 'Sierra Leone',
      shortDescription: 'SL',
      listPriority: 255,

      standardCode: 'SL',

      name: 'Sierra Leone',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SM,
      literal: 'SM',
      description: 'San Marino',
      shortDescription: 'SM',
      listPriority: 255,

      standardCode: 'SM',

      name: 'San Marino',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SN,
      literal: 'SN',
      description: 'Senegal',
      shortDescription: 'SN',
      listPriority: 255,

      standardCode: 'SN',

      name: 'Senegal',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SO,
      literal: 'SO',
      description: 'Somalia',
      shortDescription: 'SO',
      listPriority: 255,

      standardCode: 'SO',

      name: 'Somalia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SR,
      literal: 'SR',
      description: 'Suriname',
      shortDescription: 'SR',
      listPriority: 255,

      standardCode: 'SR',

      name: 'Suriname',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ST,
      literal: 'ST',
      description: 'Sao Tome And Principe',
      shortDescription: 'ST',
      listPriority: 255,

      standardCode: 'ST',

      name: 'Sao Tome And Principe',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.XX,
      literal: 'XX',
      description: 'Exception Country',
      shortDescription: 'XX',
      listPriority: 255,

      standardCode: 'XX',

      name: 'Exception Country',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SV,
      literal: 'SV',
      description: 'El Salvador',
      shortDescription: 'SV',
      listPriority: 255,

      standardCode: 'SV',

      name: 'El Salvador',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SY,
      literal: 'SY',
      description: 'Syria',
      shortDescription: 'SY',
      listPriority: 255,

      standardCode: 'SY',

      name: 'Syria',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SZ,
      literal: 'SZ',
      description: 'Swaziland',
      shortDescription: 'SZ',
      listPriority: 255,

      standardCode: 'SZ',

      name: 'Swaziland',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TC,
      literal: 'TC',
      description: 'Turks And Caicos Islands',
      shortDescription: 'TC',
      listPriority: 255,

      standardCode: 'TC',

      name: 'Turks And Caicos Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TD,
      literal: 'TD',
      description: 'Chad',
      shortDescription: 'TD',
      listPriority: 255,

      standardCode: 'TD',

      name: 'Chad',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TG,
      literal: 'TG',
      description: 'Togo',
      shortDescription: 'TG',
      listPriority: 255,

      standardCode: 'TG',

      name: 'Togo',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TH,
      literal: 'TH',
      description: 'Thailand',
      shortDescription: 'TH',
      listPriority: 255,

      standardCode: 'TH',

      name: 'Thailand',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TJ,
      literal: 'TJ',
      description: 'Tajikistan',
      shortDescription: 'TJ',
      listPriority: 255,

      standardCode: 'TJ',

      name: 'Tajikistan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TK,
      literal: 'TK',
      description: 'Tokelau',
      shortDescription: 'TK',
      listPriority: 255,

      standardCode: 'TK',

      name: 'Tokelau',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TM,
      literal: 'TM',
      description: 'Turkmenistan',
      shortDescription: 'TM',
      listPriority: 255,

      standardCode: 'TM',

      name: 'Turkmenistan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TN,
      literal: 'TN',
      description: 'Tunisia',
      shortDescription: 'TN',
      listPriority: 255,

      standardCode: 'TN',

      name: 'Tunisia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TO,
      literal: 'TO',
      description: 'Tonga',
      shortDescription: 'TO',
      listPriority: 255,

      standardCode: 'TO',

      name: 'Tonga',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TL,
      literal: 'TL',
      description: 'Timor-Leste',
      shortDescription: 'TL',
      listPriority: 255,

      standardCode: 'TL',

      name: 'Timor-Leste',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TR,
      literal: 'TR',
      description: 'Turkey',
      shortDescription: 'TR',
      listPriority: 255,

      standardCode: 'TR',

      name: 'Turkey',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TT,
      literal: 'TT',
      description: 'Trinidad And Tobago',
      shortDescription: 'TT',
      listPriority: 255,

      standardCode: 'TT',

      name: 'Trinidad And Tobago',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TV,
      literal: 'TV',
      description: 'Tuvalu',
      shortDescription: 'TV',
      listPriority: 255,

      standardCode: 'TV',

      name: 'Tuvalu',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TW,
      literal: 'TW',
      description: 'Taiwan',
      shortDescription: 'TW',
      listPriority: 255,

      standardCode: 'TW',

      name: 'Taiwan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TZ,
      literal: 'TZ',
      description: 'Tanzania',
      shortDescription: 'TZ',
      listPriority: 255,

      standardCode: 'TZ',

      name: 'Tanzania',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.UA,
      literal: 'UA',
      description: 'Ukraine',
      shortDescription: 'UA',
      listPriority: 255,

      standardCode: 'UA',

      name: 'Ukraine',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.UG,
      literal: 'UG',
      description: 'Uganda',
      shortDescription: 'UG',
      listPriority: 255,

      standardCode: 'UG',

      name: 'Uganda',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.UM,
      literal: 'UM',
      description: 'Minor Outlying Islands (US)',
      shortDescription: 'UM',
      listPriority: 255,

      standardCode: 'UM',

      name: 'Minor Outlying Islands (US)',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.US,
      literal: 'US',
      description: 'United States',
      shortDescription: 'US',
      listPriority: 0,

      standardCode: 'US',

      name: 'United States',

      isRelevant: true,

      effectiveCurrencyCode: 1,

      addressVerificationEnabled: true,

      isTextMessagingSupported: true,

      typeName: "Country"
   },
   {
      code: Country_.UY,
      literal: 'UY',
      description: 'Uruguay',
      shortDescription: 'UY',
      listPriority: 255,

      standardCode: 'UY',

      name: 'Uruguay',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.UZ,
      literal: 'UZ',
      description: 'Uzbekistan',
      shortDescription: 'UZ',
      listPriority: 255,

      standardCode: 'UZ',

      name: 'Uzbekistan',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VA,
      literal: 'VA',
      description: 'Vatican City',
      shortDescription: 'VA',
      listPriority: 255,

      standardCode: 'VA',

      name: 'Vatican City',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VC,
      literal: 'VC',
      description: 'Saint Vincent And The Grenadines',
      shortDescription: 'VC',
      listPriority: 255,

      standardCode: 'VC',

      name: 'Saint Vincent And The Grenadines',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VE,
      literal: 'VE',
      description: 'Venezuela',
      shortDescription: 'VE',
      listPriority: 255,

      standardCode: 'VE',

      name: 'Venezuela',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VG,
      literal: 'VG',
      description: 'Virgin Islands, British',
      shortDescription: 'VG',
      listPriority: 255,

      standardCode: 'VG',

      name: 'Virgin Islands, British',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VI,
      literal: 'VI',
      description: 'Virgin Islands, U.S.',
      shortDescription: 'VI',
      listPriority: 255,

      standardCode: 'VI',

      name: 'Virgin Islands, U.S.',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VN,
      literal: 'VN',
      description: 'Vietnam',
      shortDescription: 'VN',
      listPriority: 255,

      standardCode: 'VN',

      name: 'Vietnam',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.VU,
      literal: 'VU',
      description: 'Vanuatu',
      shortDescription: 'VU',
      listPriority: 255,

      standardCode: 'VU',

      name: 'Vanuatu',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.WF,
      literal: 'WF',
      description: 'Wallis And Futuna',
      shortDescription: 'WF',
      listPriority: 255,

      standardCode: 'WF',

      name: 'Wallis And Futuna',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.WS,
      literal: 'WS',
      description: 'Samoa',
      shortDescription: 'WS',
      listPriority: 255,

      standardCode: 'WS',

      name: 'Samoa',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.YE,
      literal: 'YE',
      description: 'Yemen',
      shortDescription: 'YE',
      listPriority: 255,

      standardCode: 'YE',

      name: 'Yemen',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.YT,
      literal: 'YT',
      description: 'Mayotte',
      shortDescription: 'YT',
      listPriority: 255,

      standardCode: 'YT',

      name: 'Mayotte',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.YU,
      literal: 'YU',
      description: 'Yugoslavia',
      shortDescription: 'YU',
      listPriority: 255,

      standardCode: 'YU',

      name: 'Yugoslavia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ZA,
      literal: 'ZA',
      description: 'South Africa',
      shortDescription: 'ZA',
      listPriority: 255,

      standardCode: 'ZA',

      name: 'South Africa',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ZM,
      literal: 'ZM',
      description: 'Zambia',
      shortDescription: 'ZM',
      listPriority: 255,

      standardCode: 'ZM',

      name: 'Zambia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CD,
      literal: 'CD',
      description: 'Congo (Kinshasa) (Zaire)',
      shortDescription: 'CD',
      listPriority: 255,

      standardCode: 'CD',

      name: 'Congo (Kinshasa) (Zaire)',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ZW,
      literal: 'ZW',
      description: 'Zimbabwe',
      shortDescription: 'ZW',
      listPriority: 255,

      standardCode: 'ZW',

      name: 'Zimbabwe',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.RS,
      literal: 'RS',
      description: 'Serbia',
      shortDescription: 'RS',
      listPriority: 255,

      standardCode: 'RS',

      name: 'Serbia',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KV,
      literal: 'KV',
      description: 'Kosovo',
      shortDescription: 'KV',
      listPriority: 255,

      standardCode: 'KV',

      name: 'Kosovo',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.WE,
      literal: 'WE',
      description: 'West Bank',
      shortDescription: 'WE',
      listPriority: 255,

      standardCode: 'WE',

      name: 'West Bank',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.SX,
      literal: 'SX',
      description: 'Sint Maarten',
      shortDescription: 'SX',
      listPriority: 255,

      standardCode: 'SX',

      name: 'Sint Maarten',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CS,
      literal: 'CS',
      description: 'Serbia (prior to 2001)',
      shortDescription: 'CS',
      listPriority: 255,

      standardCode: 'CS',

      name: 'Serbia (prior to 2001)',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.JE,
      literal: 'JE',
      description: 'Jersey',
      shortDescription: 'JE',
      listPriority: 255,

      standardCode: 'JE',

      name: 'Jersey',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.FQ,
      literal: 'FQ',
      description: 'Baker Island',
      shortDescription: 'FQ',
      listPriority: 255,

      standardCode: 'FQ',

      name: 'Baker Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.HQ,
      literal: 'HQ',
      description: 'Howland Island',
      shortDescription: 'HQ',
      listPriority: 255,

      standardCode: 'HQ',

      name: 'Howland Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.DQ,
      literal: 'DQ',
      description: 'Jarvis Island',
      shortDescription: 'DQ',
      listPriority: 255,

      standardCode: 'DQ',

      name: 'Jarvis Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.JQ,
      literal: 'JQ',
      description: 'Johnston Atoll',
      shortDescription: 'JQ',
      listPriority: 255,

      standardCode: 'JQ',

      name: 'Johnston Atoll',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.KQ,
      literal: 'KQ',
      description: 'Kingman Reef',
      shortDescription: 'KQ',
      listPriority: 255,

      standardCode: 'KQ',

      name: 'Kingman Reef',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MI,
      literal: 'MI',
      description: 'Midway Islands',
      shortDescription: 'MI',
      listPriority: 255,

      standardCode: 'MI',

      name: 'Midway Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BQ,
      literal: 'BQ',
      description: 'Navassa Island',
      shortDescription: 'BQ',
      listPriority: 255,

      standardCode: 'BQ',

      name: 'Navassa Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.LQ,
      literal: 'LQ',
      description: 'Palmyra Atoll',
      shortDescription: 'LQ',
      listPriority: 255,

      standardCode: 'LQ',

      name: 'Palmyra Atoll',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.WQ,
      literal: 'WQ',
      description: 'Wake Island',
      shortDescription: 'WQ',
      listPriority: 255,

      standardCode: 'WQ',

      name: 'Wake Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.AH,
      literal: 'AH',
      description: 'Ashmore And Cartier Islands',
      shortDescription: 'AH',
      listPriority: 255,

      standardCode: 'AH',

      name: 'Ashmore And Cartier Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BX,
      literal: 'BX',
      description: 'Bassas Da India',
      shortDescription: 'BX',
      listPriority: 255,

      standardCode: 'BX',

      name: 'Bassas Da India',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CP,
      literal: 'CP',
      description: 'Clipperton Island',
      shortDescription: 'CP',
      listPriority: 255,

      standardCode: 'CP',

      name: 'Clipperton Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.CQ,
      literal: 'CQ',
      description: 'Coral Sea Islands',
      shortDescription: 'CQ',
      listPriority: 255,

      standardCode: 'CQ',

      name: 'Coral Sea Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.EU,
      literal: 'EU',
      description: 'Europa Island',
      shortDescription: 'EU',
      listPriority: 255,

      standardCode: 'EU',

      name: 'Europa Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TF,
      literal: 'TF',
      description: 'French Southern, Antartic Lands',
      shortDescription: 'TF',
      listPriority: 255,

      standardCode: 'TF',

      name: 'French Southern, Antartic Lands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GZ,
      literal: 'GZ',
      description: 'Gaza Strip',
      shortDescription: 'GZ',
      listPriority: 255,

      standardCode: 'GZ',

      name: 'Gaza Strip',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GO,
      literal: 'GO',
      description: 'Glorioso Islands',
      shortDescription: 'GO',
      listPriority: 255,

      standardCode: 'GO',

      name: 'Glorioso Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.GG,
      literal: 'GG',
      description: 'Guernsey',
      shortDescription: 'GG',
      listPriority: 255,

      standardCode: 'GG',

      name: 'Guernsey',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.IM,
      literal: 'IM',
      description: 'Isle Of Man',
      shortDescription: 'IM',
      listPriority: 255,

      standardCode: 'IM',

      name: 'Isle Of Man',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.JU,
      literal: 'JU',
      description: 'Juan De Nova Island',
      shortDescription: 'JU',
      listPriority: 255,

      standardCode: 'JU',

      name: 'Juan De Nova Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.ME,
      literal: 'ME',
      description: 'Montenegro',
      shortDescription: 'ME',
      listPriority: 255,

      standardCode: 'ME',

      name: 'Montenegro',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.PX,
      literal: 'PX',
      description: 'Paracel Islands',
      shortDescription: 'PX',
      listPriority: 255,

      standardCode: 'PX',

      name: 'Paracel Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.BL,
      literal: 'BL',
      description: 'Saint Barthelemy',
      shortDescription: 'BL',
      listPriority: 255,

      standardCode: 'BL',

      name: 'Saint Barthelemy',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.MF,
      literal: 'MF',
      description: 'Saint Martin',
      shortDescription: 'MF',
      listPriority: 255,

      standardCode: 'MF',

      name: 'Saint Martin',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.XG,
      literal: 'XG',
      description: 'Spratly Islands',
      shortDescription: 'XG',
      listPriority: 255,

      standardCode: 'XG',

      name: 'Spratly Islands',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.TE,
      literal: 'TE',
      description: 'Tromelin Island',
      shortDescription: 'TE',
      listPriority: 255,

      standardCode: 'TE',

      name: 'Tromelin Island',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   },
   {
      code: Country_.EH,
      literal: 'EH',
      description: 'Western Sahara',
      shortDescription: 'EH',
      listPriority: 255,

      standardCode: 'EH',

      name: 'Western Sahara',

      isRelevant: false,

      effectiveCurrencyCode: 0,

      addressVerificationEnabled: false,

      isTextMessagingSupported: false,

      typeName: "Country"
   }
]

export class Country implements IDomainModel {
   code: Country_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   standardCode: string

   name: string

   isRelevant: boolean

   effectiveCurrencyCode: number

   addressVerificationEnabled: boolean

   isTextMessagingSupported: boolean

   typeName: string

   static toDomainModel(code: Country_): Country {
      return Countries.find(d => d.code === code)
   }
}
